import { BankIdErrorComponent } from '@/components/BankIdDialog/BankIdErrorComponent';
import { SwedenBankIdQrCode } from '@/features/IdentityVerification/VerificationWithBankId/SwedenBankId/SwedenBankIdQrCode';
import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import { SCRIVE_TYPE } from '@treyd-io/core/constants/auth';
import useDebouncedEffect from '@treyd-io/core/hooks/useDebouncedEffect';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';
import { ComponentLoader } from '../ComponentLoader';

interface Props {
  token?: string;
  switchSigningMethod: () => void;
  signCallback: () => void;
  cancelSignCallback: () => void;
  isPollingData: boolean;
  error?: string;
  type: SCRIVE_TYPE;
}

const BankIdQR = (props: Props) => {
  const {
    switchSigningMethod,
    cancelSignCallback,
    signCallback,
    token,
    isPollingData,
    error,
    type,
  } = props;
  const { t } = useTranslation();

  useEffectOnce(() => {
    cancelSignCallback();
  });

  useDebouncedEffect(
    () => {
      isPollingData && signCallback();
    },
    [isPollingData],
    2000
  );

  return (
    <Box>
      <DialogContent>
        <Box
          width="100%"
          bgcolor="grey.100"
          border={1}
          borderColor="grey.200"
          borderRadius={2}
          paddingY={6}>
          {token ? (
            <SwedenBankIdQrCode value={token} />
          ) : error ? (
            <BankIdErrorComponent error={error} />
          ) : (
            <Box paddingY={14}>
              <ComponentLoader />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: { sm: 'inline-flex' },
        }}>
        {switchSigningMethod && (
          <Button
            sx={{ marginInlineEnd: 'auto' }}
            type="button"
            color="info"
            onClick={switchSigningMethod}>
            {type === SCRIVE_TYPE.SIGN && t('sign_with_verification_code')}
            {type === SCRIVE_TYPE.AUTH && t('confirm_with_verification_code')}
          </Button>
        )}
      </DialogActions>
    </Box>
  );
};

export default BankIdQR;
